import React from 'react'
import { ThingMapPin } from '@fs/zion-icon'
import { baseUrl } from '@fs/zion-config'
import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import HeaderIconButton from '../../../shared/components/HeaderIconButton'

function getFhcLink({ external }) {
  const externalUrl = external ? baseUrl : ''
  return `${externalUrl}/${i18n.language}/locations/about`
}

export default function LocationIconButton({ linkName, external }) {
  const { t } = useTranslation()

  return (
    <HeaderIconButton
      Icon={ThingMapPin}
      title={t('header.locations', 'Locations')}
      to={getFhcLink({ external })}
      linkName={linkName}
      external
      data-test-id="hdr_FS_Center_Locations"
    />
  )
}
